import { TSegment } from 'types/segment';

export type TWireSegment = Partial<TSegment> & Pick<TSegment, 'id' | 'key'>;

export const normalizeSegment = (segment: TWireSegment): TSegment => ({
  id: segment.id,
  key: segment.key,
  metabaseModelId: segment.metabaseModelId ?? 0,
  attributeKeys: segment.attributeKeys ?? [],
  intervalMinutes: segment.intervalMinutes ?? 0,
  lastSyncedAt: segment.lastSyncedAt ?? null,
  merchantCount: segment.merchantCount ?? 0,
});
